import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface PhoneFrameProps {
  children: ReactNode;
  className?: string;
}

export function PhoneFrame({ children, className }: PhoneFrameProps) {
  return (
    <div
      className={cn(
        "relative mx-auto rounded-[2.25rem] bg-slate-950 p-2 shadow-[0_30px_60px_-20px_rgba(15,23,42,0.45),0_18px_36px_-18px_rgba(15,23,42,0.35)] ring-1 ring-slate-900/40",
        className,
      )}
    >
      {/* notch */}
      <div className="pointer-events-none absolute left-1/2 top-2 z-20 h-5 w-24 -translate-x-1/2 rounded-b-2xl bg-slate-950" />
      <div className="relative overflow-hidden rounded-[1.85rem] bg-white">
        {children}
      </div>
    </div>
  );
}
